import { NavLink } from "react-router";

import Avatar from "@/design/components/Avatar";
import HeaderCard from "@/design/components/HeaderCard";
import Valkyrie, { viArrowLeft, viSpinnerThird } from "@sippy-platform/valkyrie";

import { IconButton, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";

export default function LoadingPage({ message }) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  return (
    <>
      <HeaderCard
        avatar={
          !matches ? (
            <IconButton variant="avatar" component={NavLink} to="..">
              <Valkyrie icon={viArrowLeft} />
              <Avatar />
            </IconButton>
          ) : (
            <Avatar />
          )
        }
        title={message}
      />
      <Stack sx={{ textAlign: "center", pt: 8 }}>
        <Typography variant="h1" color="primary">
          <Valkyrie icon={viSpinnerThird} spin />
        </Typography>
        <Typography variant="h5">{message}</Typography>
      </Stack>
    </>
  );
}
